var AnalyticsApplication;
(function (AnalyticsApplication) {
    AnalyticsApplication["Account"] = "Account";
    AnalyticsApplication["Chromatic"] = "Chromatic";
    AnalyticsApplication["Dashboard"] = "Dashboard";
    AnalyticsApplication["Distribution"] = "Distribution";
    AnalyticsApplication["Feedback"] = "Feedback";
    AnalyticsApplication["GuestSite"] = "Guest Site";
    AnalyticsApplication["Mastering"] = "Mastering";
    AnalyticsApplication["Messages"] = "Messages";
    AnalyticsApplication["Network"] = "Network";
    AnalyticsApplication["Plugins"] = "Plugins";
    AnalyticsApplication["Pricing"] = "Pricing";
    AnalyticsApplication["Projects"] = "Projects";
    AnalyticsApplication["Samples"] = "Samples";
    AnalyticsApplication["Sessions"] = "Sessions";
    AnalyticsApplication["Platform"] = "Platform";
    AnalyticsApplication["Blog"] = "Blog";
})(AnalyticsApplication || (AnalyticsApplication = {}));

export { AnalyticsApplication };
